// apps/merchant-v3/src/components/topbar/BillingWidget.tsx
//
// Phase 6 Wave 12 Task 42 — TopBar wrapper component branching on the
// merchant's billing mode:
//
//   PREPAID → BalanceChip                 (wallet balance)
//   CREDIT  → BalanceChip                 (wallet balance — credit usage
//                                          surfaced inside /wallet)
//   INVOICE → OutstandingInvoiceWidget    (outstanding total + overdue
//                                          badge)
//
// Phase 6 Wave 16 Task 78: always-render both chips so
// the lifecycle specs find the canonical testid before checking
// `toBeVisible()`. Inactive chip is wrapped + visually hidden via
// `display:none`+`aria-hidden`; specs assert visibility for the
// branch matching the fixture's billingMode.
//
// vg-binding: PLAN:task-42
// vg-binding: PLAN:task-78
// vg-binding: P6.D-114
// vg-binding: P6.D-245
// vg-binding: P6.D-246
// vg-binding: P6.D-247
// vg-binding: P6.D-248
// vg-binding: G-13
// vg-binding: G-14
// vg-binding: G-70
// vg-binding: G-71

import {
  BILLING_MODE_INVOICE,
  useBillingMode,
} from '@/lib/billing/useBillingMode';
import { BalanceChip } from './BalanceChip';
import { OutstandingInvoiceWidget } from './OutstandingInvoiceWidget';

export function BillingWidget(): JSX.Element {
  const mode = useBillingMode();
  const isInvoice = mode === BILLING_MODE_INVOICE;
  return (
    <>
      {/* Wallet balance — now ALWAYS visible (user request): even INVOICE-mode
          merchants keep a wallet balance worth showing, so the wallet chip sits
          alongside the outstanding-invoice widget instead of being replaced by
          it. Kept in the DOM in all modes; lifecycle specs still find the
          testid. */}
      <BalanceChip />
      {/* Outstanding invoices — shown ADDITIVELY in INVOICE mode. Kept in the
          DOM (hidden) otherwise so lifecycle specs find the canonical testid. */}
      <div
        aria-hidden={isInvoice ? undefined : true}
        style={isInvoice ? undefined : { display: 'none' }}
      >
        <OutstandingInvoiceWidget />
      </div>
    </>
  );
}

export default BillingWidget;
